import { MENU } from 'bento-ordering/menus/constants/entities';

export const MENU_BASE = `/:slug/menu`;
export const MENU_ORDER_SETTING = `${MENU_BASE}/order-settings`;
export const MENU_ITEM_DETAIL = `${MENU_BASE}/:menuItemSlug`;
export const UPSELL_MENU_ITEM_DETAIL = `${MENU_BASE}/upsell/:menuItemSlug`;

export const entityPathMap = {
  [MENU]: {
    menu: MENU_BASE,
    orderSetting: MENU_ORDER_SETTING,
    menuItemDetail: MENU_ITEM_DETAIL,
    upsellMenuItemDetail: UPSELL_MENU_ITEM_DETAIL
  }
};
